import React from 'react'

const ProfileIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1550_45889" style={{ maskType:"luminance"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <path d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_1550_45889)">
    <path d="M24 0H0V24H24V0Z" fill="#405059"/>
    <path d="M22.9385 23.7469L18.6807 6.66969C18.0928 4.31182 15.7048 2.87696 13.3469 3.46485L-3.73029 7.72267C-6.08816 8.31055 -7.52302 10.6986 -6.93514 13.0564L-2.67731 30.1336C-2.08943 32.4915 0.298576 33.9264 2.65644 33.3385L19.7336 29.0807C22.0915 28.4928 23.5264 26.1048 22.9385 23.7469Z" fill="#EDD75A"/>
    <path d="M12.9443 11.7009C14.3401 12.2246 15.6661 12.0852 16.9224 11.2828" stroke="black" stroke-width="0.666667" stroke-linecap="round"/>
    <path d="M12.2644 8.42079C12.2259 8.05462 11.9721 7.78118 11.6975 7.81004C11.4228 7.83891 11.2314 8.15915 11.2699 8.52532C11.3084 8.89149 11.5622 9.16493 11.8368 9.13607C12.1115 9.1072 12.3029 8.78696 12.2644 8.42079Z" fill="black"/>
    <path d="M17.5681 7.86317C17.5296 7.497 17.2758 7.22356 17.0012 7.25242C16.7265 7.28129 16.5351 7.60153 16.5736 7.9677C16.6121 8.33387 16.8659 8.60732 17.1405 8.57845C17.4152 8.54959 17.6066 8.22935 17.5681 7.86317Z" fill="black"/>
    </g>
    </svg>
  )
}

export default ProfileIcon